const rankingItems = [
  { rank: 1, title: '庆余年·第三季', hot: '🔥 2896万', tag: '新', change: 'up' },
  { rank: 2, title: '热辣滚烫·剧场版', hot: '🔥 2451万', tag: '热', change: 'up' },
  { rank: 3, title: '与凤行·完整版', hot: '🔥 2134万', tag: '', change: 'same' },
  { rank: 4, title: '长安十二时辰·精编', hot: '🔥 1876万', tag: '', change: 'down' },
  { rank: 5, title: '熊出没·逆转时空', hot: '🔥 1623万', tag: '新', change: 'up' },
  { rank: 6, title: '新闻女王·第二季', hot: '🔥 1489万', tag: '热', change: 'up' },
  { rank: 7, title: '三体·动画大电影', hot: '🔥 1356万', tag: '', change: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="text-xs text-primary-400 whitespace-nowrap">实时热度</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">热播榜单</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            基于西瓜视频免费和91在线视频实时数据，每日更新最热门影视排行
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 hover:bg-background-200/40 rounded-lg transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm whitespace-nowrap ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-300 text-foreground-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-200 truncate group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </span>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '新' ? 'bg-accent-500/20 text-accent-400' : 'bg-primary-500/20 text-primary-400'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.hot}</span>
                <span className={`text-xs whitespace-nowrap ${
                  item.change === 'up' ? 'text-primary-400' : item.change === 'down' ? 'text-foreground-500' : 'text-foreground-500'
                }`}>
                  {item.change === 'up' ? '↑' : item.change === 'down' ? '↓' : '−'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}